import type { ApplicationState } from '@/store';

export const selectConfig = (state: ApplicationState) => state.config;
